import { BellAlertIcon, HomeIcon } from "@heroicons/react/20/solid";
import { Link, useLocation } from "react-router-dom";

export default function SubHeader() {
  const location = useLocation();

  const navItems = [
    {
      to: "/dashboard",
      label: "Dashboard",
      icon: <HomeIcon className="size-4" />,
    },
    // {
    //   to: "/",
    //   label: "Tenders / RFQs",
    //   icon: <HomeIcon className="size-4" />,
    // },
    {
      to: "/notifications",
      label: "Notifications",
      icon: <BellAlertIcon className="size-4" />,
    },
  ];

  const isActiveLink = (path: string) => {
    if (path === "/") {
      return location.pathname === path;
    }
    return location.pathname.startsWith(path);
  };

  const getLinkClasses = (path: string) => {
    const baseClasses =
      "rounded-md flex gap-1 items-center px-4 py-1 text-sm font-bold";
    return isActiveLink(path)
      ? `${baseClasses} text-slate-200 bg-slate-800`
      : `${baseClasses} text-slate-400 hover:text-slate-300 hover:bg-slate-800/50`;
  };

  return (
    <div className="bg-slate-900">
      <nav className="flex space-x-4 mx-auto max-w-6xl w-full px-4 py-3 sm:px-6 lg:px-8">
        {navItems.map((item) => (
          <Link key={item.to} to={item.to} className={getLinkClasses(item.to)}>
            {item.icon}
            {item.label}
          </Link>
        ))}
      </nav>
    </div>
  );
}
